import { TuiIconTdsIllustrationsCommonWiFiOffLight } from '@tui-react/proprietary-icons';
import React from 'react';
import intl from '../../locale';
import { NewOverlay } from '../NewOverlay';

interface NewConnectionErrorOverlayProps {
  isWebview: boolean;
  onRetry: VoidFunction;
  onClose: VoidFunction;
  isLoading?: boolean;
}

export const NewConnectionErrorOverlay: React.FC<NewConnectionErrorOverlayProps> = ({
  onRetry,
  onClose,
  isLoading,
  isWebview,
}) => {
  return (
    <NewOverlay
      onClose={onClose}
      isWebview={isWebview}
      onClick={onRetry}
      isLoading={isLoading}
      icon={<TuiIconTdsIllustrationsCommonWiFiOffLight iconSize={160} />}
      title={intl.formatMessage({ id: 'System.NewAnswerSendErrorTitle' })}
      description={intl.formatMessage({ id: 'System.NewAnswerSendErrorDescription' })}
      buttonText={intl.formatMessage({ id: 'System.NewAnswerSendErrorRetry' })}
    />
  );
};
